import { render, staticRenderFns } from "./ViewFormRF03.vue?vue&type=template&id=2817a628"
import script from "./ViewFormRF03.vue?vue&type=script&lang=js"
export * from "./ViewFormRF03.vue?vue&type=script&lang=js"
import style0 from "./ViewFormRF03.vue?vue&type=style&index=0&id=2817a628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports